<template>
  <div>
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">
      <FormItem label="产品分类" prop="classify_id" v-if="classifyIds.length > 1">
        <Select v-model="formValidate.classify_id" @on-change="classifyChange" :width="300" clearable>
          <Option v-for="item in classifyIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </FormItem>

      <FormItem label="工作类型" prop="short_video_work_type_id">
        <Select v-model="formValidate.short_video_work_type_id" :width="300" @on-change="workTypeChange" clearable>
          <Option v-for="item in workTypeIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </FormItem>

      <FormItem label="是否当做一个系列">
        <RadioGroup v-model="formValidate.video_type" type="button">
          <Radio label="是"></Radio>
          <Radio label="否"></Radio>
        </RadioGroup>
      </FormItem>
      
      <template v-if="formValidate.video_type == '是'">
            
        <FormItem label="系列名称" v-if="formValidate.video_type == '是'" prop="video_type_name">
          <Input v-model="formValidate.video_type_name" placeholder="请填写"></Input>
        </FormItem>
        
      <template v-for="(item, index) in formValidate.push_date_array">
        <FormItem :label="'发布时间' + (index + 1)">
          <Row>
            <Col span="18">
              <TimePicker v-model="item.value" format="HH:mm" placeholder="选择日期和时间"></TimePicker>
            </Col>
            <Col span="4" offset="1">
            <Button @click="handlePushDateRemove(index)">删除</Button>
            </Col>
          </Row>
        </FormItem>
      </template>

      <FormItem>
        <Row>
          <Col span="12">
          <Button type="dashed" long @click="handlePushDateAdd" icon="md-add">添加</Button>
          </Col>
        </Row>
      </FormItem>

    </template>


      <FormItem label="是否上传到印尼服务器">
        <RadioGroup v-model="formValidate.upload_id" type="button">
          <Radio label="需要"></Radio>
          <Radio label="不需要"></Radio>
        </RadioGroup>
      </FormItem>

      <FormItem label="是否自动运行">
        <RadioGroup v-model="formValidate.auto" type="button">
          <Radio label="是"></Radio>
          <Radio label="否"></Radio>
        </RadioGroup>
      </FormItem>
      
      <FormItem label="视频链接下载视频">
        <RadioGroup v-model="formValidate.isLink" type="button">
          <Radio label="是"></Radio>
          <Radio label="否"></Radio>
        </RadioGroup>
      </FormItem>

      <FormItem label="原视频链接">
        <Input v-model="formValidate.video_url" placeholder="请填写链接地址"></Input>
      </FormItem>

      <FormItem label="请上传视频文件" v-if="formValidate.short_video_work_type_id != 4 && formValidate.short_video_work_type_id != 17">
        <input type="file" accept=".mp4" @change="handleVideoFileChange" ref="videoFileInput" />
        <label class="search-label">{{ show_video_path }}</label>
        <Button type="info" v-if='url_loadding' :loading="url_loadding">
          <span>上传中</span>
        </Button>
      </FormItem>

      <FormItem label="视频预览" v-if="this.formValidate.video_show && formValidate.short_video_work_type_id != 4 && formValidate.short_video_work_type_id != 17">
        <video :src="formValidate.videoSource" ref="video" @loadedmetadata="getVideoResolution"
          style="width: 150px; height: auto;" controls></video>
      </FormItem>

      <FormItem label="是否需要提取字幕" v-if="formValidate.short_video_work_type_id != 4 && formValidate.short_video_work_type_id != 17">
        <RadioGroup v-model="formValidate.srt_status" type="button">
          <Radio label="需要"></Radio>
          <Radio label="不需要"></Radio>
        </RadioGroup>
      </FormItem>

      <FormItem label="定位提取字幕位置"
        v-if="formValidate.videoSource && formValidate.srt_status == '需要'">
        <Button type="info" @click="handleView(1)">定位</Button>
      </FormItem>

      <FormItem label="是否需要去字幕" v-if="formValidate.short_video_work_type_id != 4 && formValidate.short_video_work_type_id != 17">
        <RadioGroup v-model="formValidate.rid_subtitles" type="button">
          <Radio label="需要"></Radio>
          <Radio label="不需要"></Radio>
        </RadioGroup>
      </FormItem>

      <FormItem label="定位消除字幕位置"
        v-if="formValidate.auto == '是' && formValidate.videoSource && formValidate.rid_subtitles == '需要'">
        <Button type="info" @click="handleView(2)">定位</Button>
      </FormItem>
      
      <template v-if="formValidate.short_video_work_type_id == 4 || formValidate.short_video_work_type_id == 17">
        <!-- <FormItem label="混剪文案">
          <Input v-model="formValidate.hj_content" type="textarea" placeholder="请填写文案"></Input>
        </FormItem> -->
        
        <FormItem label="方式">
          <RadioGroup v-model="formValidate.hj_type" type="button">
            <Radio label="混剪库中选择"></Radio>
            <Radio label="自定义上传"></Radio>
          </RadioGroup>
        </FormItem>

        <Card>
          <h3>已选择的视频片段</h3>
          <tables editable :columns="select_columns" v-model="formValidate.select_tableData"
            :loading="selectTableLoading" />
        </Card>
        <Card v-if="formValidate.hj_type == '混剪库中选择'">
          <h3>混剪库</h3>

          <!-- <FormItem label="选择分类">
            <Select v-model="formValidate.video_classify_id" :width="300" @on-change="hjVideoClassifyChange" clearable>
              <Option v-for="item in shortVideoClassifyIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem> -->
          
          <FormItem label="关键字">
            <Input v-model="formValidate.keyword" placeholder="关键字" @input="handleInput"></Input>
          </FormItem>

          <tables editable :columns="columns" v-model="tableData" :loading="tableLoading"
          @on-selection-change="selectionChange"/>
          <Row class="page-con">
            <div class="page-bottom">
              <Page :current="page" :total="total" :page-size="pageSize" :page-size-opts="[10, 20, 30, 40, 100]"
                show-sizer show-elevator @on-change="changePage" @on-page-size-change="changePageSize" />
            </div>
          </Row>

        </Card>
        <template v-else>

          <FormItem label="上传混剪片段">
          </FormItem>

          <FormItem label="视频描述">
            <Row>
              <Col span="18">
              <Input type="textarea" v-model="formValidate.hj_desc" placeholder="请填写"></Input>
              </Col>
            </Row>
          </FormItem>
          
          <FormItem label="视频">
            <input type="file" accept=".mp4,.mov" @change="handleHJVideoFileChange" ref="videoFileInput" />
            <Button type="info" v-if='url_loadding' :loading="url_loadding">
              <span>上传中</span>
            </Button>
          </FormItem>
          <FormItem>
            <Button @click="handleAdd" icon="md-add">确认</Button>
          </FormItem>

        </template>
      </template>
      <FormItem label="是否添加钩子视频">
        <RadioGroup v-model="formValidate.gz" type="button">
          <Radio label="需要"></Radio>
          <Radio label="不需要"></Radio>
        </RadioGroup>
      </FormItem>
      <template v-if="formValidate.gz == '需要'">
        <FormItem label="钩子分类">
          <Select v-model="formValidate.gz_classify_library_id" :width="300" @on-change="gz_clasify_change" clearable>
            <Option v-for="item in gzClassifyLibraryIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>

        <FormItem label="钩子视频库" prop="gz_library_id">
          <Select v-model="formValidate.gz_library_id" :width="300" @on-change="gzVideoChange" clearable>
            <Option v-for="item in gzLibraryIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="视频预览" v-if="this.formValidate.gz_library_id != ''">
          <video :src="formValidate.gz_videoSource" ref="video" style="width: 150px; height: auto;" controls></video>
        </FormItem>
      </template>

      <FormItem label="是否需要换脸">
        <RadioGroup v-model="formValidate.covert_face" type="button">
          <Radio label="需要"></Radio>
          <Radio label="不需要"></Radio>
        </RadioGroup>
      </FormItem>

      <FormItem label="请上传需要被换的脸" v-if="formValidate.covert_face == '需要'">
        <input type="file" accept=".png,.jpg,.jpeg" @change="handleFacePathChange" ref="facePathFileInput" />
        <label class="search-label">{{ show_face_path }}</label>
      </FormItem>

      <FormItem label="是否需要生成口型" v-if="formValidate.short_video_work_type_id == 3 || formValidate.short_video_work_type_id == 17">
        <RadioGroup v-model="formValidate.covert_mouth" type="button">
          <Radio label="需要"></Radio>
          <Radio label="不需要"></Radio>
        </RadioGroup>
      </FormItem>

      <FormItem label="选择口播视频" prop="mouth_library_id"
        v-if="formValidate.covert_mouth == '需要'">
        <Select v-model="formValidate.mouth_library_id">
          <Option v-for="item in mouthLibraryList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </FormItem>

      <template v-if="formValidate.short_video_work_type_id == 3">
        
        <FormItem label="文案">
          <Input v-model="formValidate.content" type="textarea" placeholder="请填写文案"></Input>
        </FormItem>
        
        <FormItem label="热点" >
          <Input v-model="formValidate.hot" type="textarea" placeholder="请添加口播文案的热点"></Input>
        </FormItem>

        <template v-for="(item, index) in formValidate.points" v-if="formValidate.hot != ''">
        <FormItem :label="'观点' + (index + 1)">
          <Row>
            <Col span="18">
            <Input type="text" v-model="item.value" placeholder="请填写"></Input>
            </Col>
            <Col span="4" offset="1">
            <Button @click="handlePointRemove(index)">删除</Button>
            </Col>
          </Row>
        </FormItem>
      </template>

      <FormItem>
        <Row>
          <Col span="12">
          <Button type="dashed" long @click="handlePointAdd" icon="md-add" v-if="formValidate.hot != ''">添加观点</Button>
          </Col>
        </Row>
      </FormItem>

      <FormItem label="自己的观点" v-if="formValidate.points.length > 0">
        <Input v-model="formValidate.point" placeholder="请填写自己的观点"></Input>
      </FormItem>

      
      <FormItem label="虚拟经历" v-if="formValidate.hot != ''">
        <Input v-model="formValidate.virtual_experience" type="textarea" placeholder="请填写个人虚拟经历"></Input>
      </FormItem>
      </template>

    <template>

      <FormItem label="选择印尼语音">
          <Select v-model="formValidate.audio_model_id">
            <Option v-for="item in audioModelIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>

        <FormItem label="语音试听">
          <audio :src="audioUrl + audio_data[formValidate.audio_model_id] + '.wav'" controls></audio>
        </FormItem>

        <FormItem label="填选择英语|中文语音">
          <Select v-model="formValidate.en_audio_model_id">
            <Option v-for="item in enAudioModelIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>

        <FormItem label="语音试听">
          <audio :src="enAudioUrl + en_audio_data[formValidate.en_audio_model_id] + '.mp3'" controls></audio>
        </FormItem>

        <FormItem label="中英文语言设置">
          <label>语速</label>
          <InputNumber style="margin-left: 5px;" max=10 :min=1 v-model="formValidate.speed"></InputNumber>
          <label style="margin-left: 10px;">白话</label>
          <InputNumber style="margin-left: 5px;" max=2 :min=1 v-model="formValidate.oral"></InputNumber>
          <label style="margin-left: 10px;">停顿</label>
          <InputNumber style="margin-left: 5px;" max=7 :min=1 v-model="formValidate.laugh"></InputNumber>
        </FormItem>

    </template>

      <FormItem label="是否去掉原始背景音乐" v-if="formValidate.auto == '是'">
        <RadioGroup v-model="formValidate.bgm">
          <Radio label="是"></Radio>
          <Radio label="否"></Radio>
        </RadioGroup>
      </FormItem>

      <FormItem label="选择背景音乐分类" v-if="formValidate.bgm == '是' && formValidate.auto == '是'">
        <Select v-model="formValidate.music_classify_id" @on-change="musicClassifyChange">
          <Option v-for="item in musicLibraryClassify" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </FormItem>

      <FormItem label="选择背景音乐" prop='music_id' v-if="formValidate.bgm == '是' && formValidate.auto == '是'">
        <Select v-model="formValidate.music_id" @on-change="musicChange">
          <Option v-for="item in musicLibrary" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </FormItem>

      <FormItem label="背景音乐试听" v-if="formValidate.bgm == '是' && formValidate.auto == '是'">
        <audio :src="bgm" controls></audio>
      </FormItem>

      <FormItem label="选择分类">
        <Select v-model="formValidate.shortVideoClassify" :width="300" @on-change="videoClassifyChange" clearable>
          <Option v-for="item in shortVideoClassifyIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </FormItem>

      <FormItem label="选择平台">
        <Select v-model="formValidate.live_id" @on-change="liveChange" clearable>
          <Option v-for="item in liveIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </FormItem>

      <template v-for="(item, index) in formValidate.selectedUser">
        <FormItem :label="'已选择的账号' + (index + 1)">
          <Row>
            <Col span="18">
            <Input type="text" disabled v-model="item.value" placeholder=""></Input>
            </Col>
            <Col span="4" offset="1">
            <Button @click="handleUserRemove(index)">删除</Button>
            </Col>
          </Row>
        </FormItem>
      </template>

      <FormItem label="选择账号" prop="dy_user_id">
        <Select v-model="formValidate.dy_user_id" :width="300" @on-change="userChange" clearable>
          <Option v-for="item in userIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </FormItem>

      <FormItem label="选择视频语言" prop="language">
        <Select v-model="formValidate.language" clearable>
          <Option v-for="item in languages" :value="item.value" :key="item.value">{{ item.name }}</Option>
        </Select>
      </FormItem>

      <FormItem label="上次插入广告的时间:">
        <span>{{ formValidate.pre_advertisement_time }}</span>
      </FormItem>

      <FormItem label="插入广告的方式">
        <Select v-model="formValidate.advertisement_type_id" clearable>
          <Option v-for="item in advertisementIds" :value="item.value" :key="item.value">{{ item.name }}</Option>
        </Select>
      </FormItem>

      <template v-if="formValidate.advertisement_type_id > 1">
        
        <template v-if="formValidate.advertisement_type_id == 2">
          <FormItem label="视频中间插入广告(秒):" v-if="formValidate.advertisement_type_id == 2 && formValidate.short_video_work_type_id != 4 && formValidate.short_video_work_type_id != 17">
            <InputNumber :min="1" v-model="formValidate.advertisement_second"></InputNumber>
          </FormItem>
          
          <FormItem label="在第几个视频后插入广告:" v-else>
            <InputNumber :max="formValidate.select_tableData.length" :min="1" v-model="formValidate.advertisement_second"></InputNumber>
          </FormItem>
      </template>

        <FormItem label="广告文案">
          <Input v-model="formValidate.advertisement_content" placeholder="请填写广告文案" type="textarea"></Input>
        </FormItem>
        
        <FormItem label="广告视频库" prop="advertisement_library_id">
          <Select v-model="formValidate.advertisement_library_id" :width="300" @on-change="advertisementVideoChange"
            clearable>
            <Option v-for="item in advertisementLibraryIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>

        <FormItem label="视频预览" v-if="formValidate.advertisement_videoSource">
          <video :src="formValidate.advertisement_videoSource" ref="video" style="width: 150px; height: auto;"
            controls></video>
        </FormItem>

      </template>

      <FormItem label="切片标题">
        <Input v-model="formValidate.title" placeholder="请填写切片标题"></Input>
      </FormItem>

      <FormItem label="封面标题">
        <Input v-model="formValidate.cover_title" placeholder="请填写封面标题"></Input>
      </FormItem>

      <FormItem label="视频标题">
        <Input v-model="formValidate.video_title" type="textarea" placeholder="请填写视频标题"></Input>
      </FormItem>

      <FormItem label="hashtag">
          <Select v-model="hashtag" :width="300" @on-change="hashtagVideoChange"
            clearable filterable>
            <Option v-for="item in hashtagList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
      </FormItem>

      <!-- <FormItem label="视频简介" prop="video_desc">
        <Input v-model="formValidate.video_desc" type="textarea" placeholder="请填写视频简介"></Input>
      </FormItem> -->

      <FormItem label="发布时间">
        <RadioGroup v-model="formValidate.push_date_type">
          <Radio label="立即发布"></Radio>
          <Radio label="定时发布"></Radio>
        </RadioGroup>
      </FormItem>

      <FormItem label="选择发布时间" prop="push_date" v-if="formValidate.push_date_type == '定时发布'">
        <DatePicker type="datetime" placeholder="选择日期和时间" @on-change="handleChange"></DatePicker>
      </FormItem>

      <!-- <template v-for="(item, index) in formValidate.goodItems">
        <FormItem :label="'金句评论' + (index + 1)">
          <Row>
            <Col span="18">
            <Input type="text" v-model="item.value" placeholder="请填写"></Input>
            </Col>
            <Col span="4" offset="1">
            <Button @click="handleGoodCommentRemove(index)">删除</Button>
            </Col>
          </Row>
        </FormItem>
      </template>

      <FormItem>
        <Row>
          <Col span="12">
          <Button type="dashed" long @click="handleGoodAdd" icon="md-add">添加金句</Button>
          </Col>
        </Row>
      </FormItem>

      <template v-for="(item, index) in formValidate.blackItems">
        <FormItem :label="'黑粉评论' + (index + 1)">
          <Row>
            <Col span="18">
            <Input type="text" v-model="item.value" placeholder="请填写"></Input>
            </Col>
            <Col span="4" offset="1">
            <Button @click="handleBlackCommentRemove(index)">删除</Button>
            </Col>
          </Row>
        </FormItem>
      </template>

      <FormItem>
        <Row>
          <Col span="12">
          <Button type="dashed" long @click="handleBlackAdd" icon="md-add">添加黑粉</Button>
          </Col>
        </Row>
      </FormItem> -->

      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button type="primary" @click="handleSubmit('formValidate')" style="margin-left: 8px">提交</Button>
      </FormItem>
    </Form>

    <modal title="View Image" v-model="visible" footer-hide :width="modal_width">
      <Button type="error" @click="deleteRect" style="margin-left: 8px">删除</Button>

      <label v-if="this.flag == 1">提取字幕定位框数量:{{formValidate.srt_rect_array.length}}</label>

      <label v-else>去字幕定位框数量:{{formValidate.rect_array.length}}</label>

      <canvas ref="canvas" @mousedown="startDrawing" @mousemove="drawRect" @mouseup="endDrawing"></canvas>
    </modal>

  </div>
</template>

<script>
import params from '../argu-page/params.vue'
import moment from 'moment';
import Tables from "_c/tables/table-only.vue";
import { getStrategyUser } from "@/api/data";
const { v4: uuidv4 } = require('uuid');
import { uploadIdFile, uploadFile, getTimeDifference} from "@/api/uploadOss";
import {
  getPreAdvertisementTime, getGZLibrary, getAdvertisementLibrary,
  getShortVideoClassify, gz_library_classify, music_library_list, get_hj_library_list,
  mouth_library_list, getAdvertisementType
} from "@/api/data";
import config from '@/config'
const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro

export default {
  components: { params, Tables },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => { }
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      listStyle: {
        width: '300px'
      },
      url_loadding: false,
      gz_loadding: false,
      advertisement_loadding: false,
      classifyIds: [],
      userIds: [],
      hashtag:'',
      workTypeIds: [],
      shortVideoClassifyIds: [],
      languages: [{ name: '中文', value: 'Chinese' }, { name: '印尼', value: 'Indonesia' }, { name: '英文', value: 'English' }],
      pushDates: ["立即发布", "定时发布"],
      liveIds: [],
      advertisementIds: [],
      gzLibraryIds: [],
      advertisementLibraryIds: [],
      gzClassifyLibraryIds: [],
      show_video_path: '',
      show_face_path: '',
      show_gz_path: '',
      show_advertisement_path: '',
      dy_user_id: '',
      audioModelIds: [],
      enAudioModelIds:[],
      audio_data: {},
      en_audio_data: {},
      frames: [],
      musicLibrary: [],
      musicLibraryClassify: [],
      capturedFrame: null,
      modal_width: 750,
      page: 1,
      pageSize: 10,
      total: 0,
      flag:0,
      x:1,
      tableLoading: false,
      selectTableLoading: false,
      upload_loadding:false,
      bgm: '',
      audioUrl: 'https://sinano-clother.oss-cn-shenzhen.aliyuncs.com/audio/',
      enAudioUrl: 'https://sinano-clother.oss-cn-shenzhen.aliyuncs.com/audio/cn_en_audio/',
      visible: false,
      mouthLibraryList: [],
      hashtagList:[],
      music_id: '',
      select_columns: [
        { type: 'index', title: '序号', width: 100, align: "center" },
        { title: "描述", key: "video_desc", editable: true, align: "center" },
        {
          title: "视频", key: "url", editable: true, align: "center",
          render: (h, params) => {
            return params.row.url != '' ? h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.download(baseUrl == 'https://in.sinano-ai.com/api' ? params.row.id_url : params.row.url);
                    },
                  },
                },
                "查看"
              )
            ]) : h('span', '');
          }
        }, 
        {
          title: "视频话术", key: "content", editable: true, align: "center", render: (h, params) => {
            return h("Input", {
              props: {
                value: params.row.content,
                size: "small",
                type: "textarea"
              }, on: {
                'on-change': (event) => {
                  this.formValidate.select_tableData[params.index].content = event.target.value;
                }
              }
            })
          }
        },
        {
          title: "操作",
          key: "handle", align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.handleDelete(params);
                    },
                  },
                },
                "删除"
              )
            ]);
          },
        }
      ],
      columns: [
        { type: 'selection', title: '选择', width: 100, align: "center" },
        { title: "描述", key: "video_desc", editable: true, align: "center" },
        {
          title: "视频", key: "url", editable: true, align: "center",
          render: (h, params) => {
            return params.row.url != '' ? h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.download(baseUrl == 'https://in.sinano-ai.com/api' ? params.row.id_url : params.row.url);
                    },
                  },
                },
                "查看"
              )
            ]) : h('span', '');
          }
        }
      ],
      tableData: [],
      formValidate: {
        id: '',
        hot:"",
        hj_type: '混剪库中选择',
        video_classify_id:'',
        keyword:'',
        hj_content:'',
        select_tableData: [],
        selectedHjVideos: [],
        hj_library_id: '',
        hjLibraryIds: [],
        video_type:'否',
        video_type_name:'',
        hj_videoSource: '',
        push_date_type: '立即发布',
        push_date: '',
        cover_title: '',
        videoSource: '',
        content: '',
        hj_desc:'',
        hj_url:'',
        hj_id_url:'',
        bgm: '否',
        gz_videoSource: '',
        advertisement_videoSource: '',
        video_show: false,
        audio_model_id: '3',
        en_audio_model_id:'85',
        laugh:4,
        oral:2,
        speed:6,
        selectedUser: [],
        gz_classify_library_id: '',
        mouth_library_id: '',
        classify_id: '',
        gz_video_desc: '',
        music_id: '',
        advertisement_video_desc: '',
        use_advertisement_library: '使用',
        advertisement_library_id: '',
        use_gz_library: '使用',
        gz_library_id: '',
        short_video_work_type_id: '',
        shortVideoClassify: '',
        dy_user_id: '',
        music_classify_id: '',
        video_url: '',
        video_title: '',
        title: '',
        video_desc: '',
        language: 'Chinese',
        url: '',
        advertisement_type_id: '',
        pre_advertisement_time: '',
        blackItems: [],
        goodItems: [],
        push_date_array:[],
        live_id: '',
        face_url: '',
        id_url: '',
        advertisement_url: '',
        advertisement_id_url: '',
        gz_url: '',
        gz_id_url: '',
        auto: '是',
        srt_status: '不需要',
        rid_subtitles: '不需要',
        covert_face: '不需要',
        covert_mouth: '不需要',
        upload_id: '不需要',
        gz: '不需要',
        resolving_power: '',
        srt_rect_array: [],
        rect_array: [],
        hj_content: '',
        advertisement_second:0,
        advertisement_content:'',
        points:[],
        point:'',
        virtual_experience:'',
        isLink:'否'
      },
      org_formValidate: {
        id: '',
        hot:"",
        hj_type: '混剪库中选择',
        hj_content:'',
        select_tableData: [],
        selectedHjVideos: [],
        hj_library_id: '',
        hjLibraryIds: [],
        hj_videoSource: '',
        video_type:'否',
        video_type_name:'',
        push_date_type: '立即发布',
        push_date: '',
        cover_title: '',
        videoSource: '',
        content: '',
        hj_desc:'',
        hj_url:'',
        hj_id_url:'',
        bgm: '否',
        gz_videoSource: '',
        advertisement_videoSource: '',
        video_show: false,
        audio_model_id: '3',
        en_audio_model_id:'85',
        laugh:4,
        oral:2,
        speed:6,
        selectedUser: [],
        gz_classify_library_id: '',
        mouth_library_id: '',
        classify_id: '',
        gz_video_desc: '',
        music_id: '',
        advertisement_video_desc: '',
        use_advertisement_library: '使用',
        advertisement_library_id: '',
        use_gz_library: '使用',
        gz_library_id: '',
        short_video_work_type_id: '',
        shortVideoClassify: '',
        dy_user_id: '',
        music_classify_id: '',
        video_url: '',
        video_title: '',
        title: '',
        video_desc: '',
        language: 'Chinese',
        url: '',
        advertisement_type_id: '',
        pre_advertisement_time: '',
        blackItems: [],
        goodItems: [],
        push_date_array:[],
        live_id: '',
        face_url: '',
        id_url: '',
        advertisement_url: '',
        advertisement_id_url: '',
        gz_url: '',
        gz_id_url: '',
        auto: '是',
        srt_status: '不需要',
        rid_subtitles: '不需要',
        covert_face: '不需要',
        covert_mouth: '不需要',
        upload_id: '不需要',
        gz: '不需要',
        resolving_power: '',
        srt_rect_array: [],
        rect_array: [],
        hj_content: '',
        advertisement_second:0,
        advertisement_content:'',
        points:[],
        point:'',
        virtual_experience:'',
        isLink:'否'
      },
      ruleValidate: {
        classify_id: [
          {
            required: true,
            message: '分类必须选择',
            trigger: 'change'
          }
        ],
        short_video_work_type_id: [
          {
            required: true,
            message: '工作类型必须选择',
            trigger: 'change'
          }
        ],
        audio_model_id: [
          {
            required: true,
            message: '语音必须选择',
            trigger: 'change'
          }
        ],
        gz_library_id: [
          {
            required: true,
            message: '钩子视频必须选择',
            trigger: 'change'
          }
        ],
        advertisement_library_id: [
          {
            required: true,
            message: '广告视频必须选择',
            trigger: 'change'
          }
        ],
        mouth_library_id: [
          {
            required: true,
            message: '口播视频需要选择',
            trigger: 'change'
          }
        ],
        music_id: [
          {
            required: true,
            message: '背景音乐需要选择',
            trigger: 'change'
          }
        ],
        language: [
          {
            required: true,
            message: '选择视频语言',
            trigger: 'change'
          }
        ],
        dy_user_id: [
          {
            required: true,
            message: '选择账号',
            trigger: 'change'
          }
        ],
        video_url: [
          {
            required: true,
            message: '链接地址必须填写',
            trigger: 'bulr'
          }
        ],        
        video_type_name: [
          {
            required: true,
            message: '链接地址必须填写',
            trigger: 'bulr'
          }
        ],
        advertisement_video_desc: [
          {
            required: true,
            message: '广告描述必须填写',
            trigger: 'bulr'
          }
        ],
        gz_video_desc: [
          {
            required: true,
            message: '钩子描述必须填写',
            trigger: 'bulr'
          }
        ],
        url: [
          {
            required: true,
            message: '必须上传视频',
            trigger: 'bulr'
          }
        ],
        gz_url: [
          {
            required: true,
            message: '必须上传视频',
            trigger: 'bulr'
          }
        ],
        advertisement_url: [
          {
            required: true,
            message: '必须上传视频',
            trigger: 'bulr'
          }
        ],
        advertisement_url: [
          {
            required: true,
            message: '必须上传视频',
            trigger: 'bulr'
          }
        ]

      },
      canvas: null,
      ctx: null,
      drawing: false,
      startX: 0,
      startY: 0,
      endX: 0,
      endY: 0,
      videoElement: null
    }
  },
  watch: {
    resetFlag(resetFlag) {
      this.handleReset('formValidate')
      if (this.$refs.videoFileInput != null)
        this.$refs.videoFileInput.value = ''

      if (this.$refs.facePathFileInput != null)
        this.$refs.facePathFileInput.value = ''
    }
  },
  methods: {
    handleInput(event) {
      // 处理输入事件
      this.handleSearch()
    },
    download(url){
      window.open(url, '_blank');
    },
    handleAdd(){
      if (this.formValidate.hj_desc.length == 0){
        this.$Message.error('请填写视频描述');
        return
      }

      if (this.formValidate.hj_url == 0){
        this.$Message.error('请上传视频片段');
        return
      }

      this.formValidate.select_tableData.push({video_desc: this.formValidate.hj_desc, url: this.formValidate.hj_url, id_url: this.formValidate.hj_id_url, id:0, content:'', type: 1})
    },
    async handleHJVideoFileChange(e) {
      const file = e.target.files[0];
        if (!file) return;

      this.url_loadding = true
      this.upload_loadding = true
        // 上传文件
        let currentDate = moment().format('YYYY-MM-DD');
        const uuid = uuidv4()
        // 上传文件
        var name = file.name.substring(file.name.lastIndexOf('.'))

        var result = null
        if (baseUrl == 'https://in.sinano-ai.com/api'){
          result = await uploadIdFile('short_video/' + currentDate + "/hj_library/" + uuid + name, file);
          this.formValidate.hj_id_url = result
        }else{
          result = await uploadFile('short_video/' + currentDate + "/hj_library/" + uuid + name, file);
          this.formValidate.hj_url = result
        }

        if (result == ''){
          this.$Message.error('上传失败');
          this.$refs.videoFileInput.value = ''
        }else{
          this.$Message.info('上传成功');
          this.formValidate.hj_url = result
        }

        this.url_loadding = false
    },
    selectionChange(selection) {
      var tempData = []
      for (var i = 0; i < this.formValidate.select_tableData.length; i++){
        if (this.formValidate.select_tableData[i].id == 0){
          tempData.push(this.formValidate.select_tableData[i])
        }
      }

      this.formValidate.select_tableData = tempData
      for (var i = 0; i < selection.length; i++) {
        this.formValidate.select_tableData.push({ video_desc: selection[i].video_desc, url: selection[i].url, id_url: selection[i].id_url, id: selection[i].id, content:'', type: 1})
      }
    },
    handleDelete(params) {
      this.formValidate.select_tableData.splice(params.index, 1)
    },
    changePage(page) {
      this.page = page;
      this.handleSearch();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.handleSearch();
    },
    handleSearch() {
      this.tableLoading = true
      let params = {
        page: this.page,
        pageSize: this.pageSize,
        keyword: this.formValidate.keyword
      };
      get_hj_library_list(params).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.tableLoading = false
      });
    },
    handlePushDateChange(index){
      console.info(this.formValidate.push_date_array[index].value)
    },
    handleChange(value) {
      this.formValidate.push_date = value
    },
    hashtagVideoChange(value){
      for (var i = 0; i < this.hashtagList.length; i++) {
        if (value == this.hashtagList[i].id) {
          var name = this.hashtagList[i].name
          if (name.startsWith('#')){
            this.formValidate.video_title += " " + name
          }else{
            this.formValidate.video_title += " #" + name
          }

          break
        }
      }
    },
    advertisementVideoChange(value) {
      for (var i = 0; i < this.advertisementLibraryIds.length; i++) {
        if (value == this.advertisementLibraryIds[i].id) {
          this.formValidate.advertisement_videoSource = baseUrl == 'https://in.sinano-ai.com/api' ? this.advertisementLibraryIds[i].id_url : this.advertisementLibraryIds[i].url
          break
        }
      }
    },
    gzVideoChange(value) {
      for (var i = 0; i < this.gzLibraryIds.length; i++) {
        if (value == this.gzLibraryIds[i].id) {
          this.formValidate.gz_videoSource = baseUrl == 'https://in.sinano-ai.com/api' ? this.gzLibraryIds[i].id_url : this.gzLibraryIds[i].url
          break
        }
      }
    },
    get_music_library(status = false) {
      var params = {
        classify_id: this.formValidate.music_classify_id
      }
      music_library_list(params).then((res) => {
        var list = res.data.data.records;
        this.setMusicLibrary(list)
        if (status){
          this.formValidate.music_id = this.music_id
          for (var i = 0; i < this.musicLibrary.length; i++) {
            if (this.formValidate.music_id == this.musicLibrary[i].id) {
              this.bgm = baseUrl == 'https://in.sinano-ai.com/api' ? this.musicLibrary[i].id_url : this.musicLibrary[i].url
              break
            }
          }
        }
      });
    },
    musicClassifyChange(value) {
      this.get_music_library(false)
    },
    musicChange(value) {
      for (var i = 0; i < this.musicLibrary.length; i++) {
        if (value == this.musicLibrary[i].id) {
          this.bgm = baseUrl == 'https://in.sinano-ai.com/api' ? this.musicLibrary[i].id_url : this.musicLibrary[i].url
          break
        }
      }
    },
    deleteRect() {

      if (this.flag == 1){
        if (this.formValidate.srt_rect_array.length > 0)
          this.formValidate.srt_rect_array.splice(this.formValidate.srt_rect_array.length - 1, 1)
      }else{
        if (this.formValidate.rect_array.length > 0)
          this.formValidate.rect_array.splice(this.formValidate.rect_array.length - 1, 1)
      }
      this.clearCanvas();
      if (this.videoElement != null) {
        this.ctx.drawImage(this.videoElement, 0, 0, this.canvas.width, this.canvas.height);
        this.drawStrokeRect(this.flag == 1? this.formValidate.srt_rect_array: this.formValidate.rect_array)
      }
    },
    handleView(flag) {
      this.visible = true
      this.flag = flag
      this.captureFrame(flag == 1?this.formValidate.srt_rect_array:this.formValidate.rect_array)

    },
    startDrawing(event) {
      this.drawing = true;
      const rect = this.canvas.getBoundingClientRect();
      this.startX = event.clientX - rect.left;
      this.startY = event.clientY - rect.top;
      // 如果是定位提取字幕，那么就只能画一个框
      // if (this.flag == 1){
      //   this.formValidate.srt_rect_array = []
      // }
    },
    drawRect(event) {
      if (!this.drawing) return;
      const rect = this.canvas.getBoundingClientRect();
      this.endX = event.clientX - rect.left;
      this.endY = event.clientY - rect.top;
      
      this.clearCanvas();
      if (this.videoElement != null) {
        this.ctx.drawImage(this.videoElement, 0, 0, this.canvas.width, this.canvas.height);
        this.drawStrokeRect(this.flag == 1? this.formValidate.srt_rect_array: this.formValidate.rect_array)
      }
      this.ctx.strokeStyle = 'red';
      this.ctx.lineWidth = 1;

      this.ctx.strokeRect(this.startX, this.startY, this.endX - this.startX, this.endY - this.startY);
    },
    endDrawing() {
      this.drawing = false;

      if (this.flag == 1){
        this.formValidate.srt_rect_array.push({ startX: this.startX, startY: this.startY, endX: this.endX, endY: this.endY })
      }else{
        this.formValidate.rect_array.push({ startX: this.startX, startY: this.startY, endX: this.endX, endY: this.endY })
      }
    },
    clearCanvas() {
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    },
    captureFrame(rect_array) {

      if (this.videoElement == null) {
        this.videoElement = this.$refs.video;
      }
      if (this.canvas == null) {
        const canvas = this.$refs.canvas;
        this.canvas = canvas;
        this.ctx = canvas.getContext('2d');
        canvas.width = this.videoElement.videoWidth / this.x;
        canvas.height = this.videoElement.videoHeight / this.x;
      }

      this.modal_width = this.canvas.width + 30
      this.clearCanvas()
      this.ctx.drawImage(this.videoElement, 0, 0, this.canvas.width, this.canvas.height);
      this.ctx.strokeStyle = 'red';
      this.ctx.lineWidth = 1;
      this.drawStrokeRect(rect_array)
    },
    drawStrokeRect(rect_array) {
      for (var i = 0; i < rect_array.length; i++) {
        this.ctx.strokeRect(rect_array[i].startX, rect_array[i].startY, rect_array[i].endX - rect_array[i].startX, rect_array[i].endY - rect_array[i].startY);
      }
    },
    getVideoResolution() {
      const video = this.$refs.video;
      if (video && video.videoWidth && video.videoHeight) {
        this.formValidate.resolving_power = video.videoWidth + "x" + video.videoHeight
      }
    },
    gz_clasify_change(value) {
      this.gz_classify_library_id = value
      var params = {
        gz_classify_id: value,
        // resolving_power: this.formValidate.resolving_power
      }
      getGZLibrary(params).then((res) => {
        var list = res.data.data.records;
        var data = new Array()
        for (var i = 0; i < list.length; i++) {
          data.push({ id: list[i].id.toString(), name: list[i].gz_desc, url: list[i].url, id_url: list[i].id_url })
        }
        this.gzLibraryIds = data
      });

    },
    initData() {
      this.userIds = []
      this.workTypeIds = []
      this.shortVideoClassifyIds = []
      this.liveIds = []
      this.advertisementIds = []
    },
    setEditData(params) {
      this.formValidate = { ...this.org_formValidate }

      this.formValidate.id = params.id
      this.formValidate.short_video_work_type_id = params.short_video_work_type_id.toString()
      this.formValidate.shortVideoClassify = params.video_classify_id.toString()
      this.formValidate.video_url = params.video_url
      this.formValidate.video_title = params.video_title
      this.formValidate.title = params.title
      this.formValidate.video_desc = params.video_desc
      this.formValidate.language = params.language
      this.formValidate.url = params.url
      this.formValidate.video_show = params.url?true:false
      this.formValidate.gz_url = params.gz_url
      this.formValidate.content = params.content
      this.formValidate.hj_content = params.content
      this.formValidate.gz_id_url = params.gz_id_url
      this.formValidate.advertisement_url = params.advertisement_url
      this.formValidate.advertisement_id_url = params.advertisement_id_url
      this.formValidate.id_url = params.id_url
      this.formValidate.face_url = params.face_url
      this.formValidate.gz_video_desc = params.gz_video_desc
      this.formValidate.cover_title = params.cover_title
      this.formValidate.push_date_type = params.push_date ? "定时发布" : "立即发布"
      this.formValidate.bgm = params.music_id != 0 ? "是" : "否"
      this.formValidate.push_date = params.push_date
      this.formValidate.advertisement_video_desc = params.advertisement_video_desc
      this.formValidate.live_id = params.live_id.toString()
      this.formValidate.gz_library_id = params.gz_library_id.toString()
      this.formValidate.classify_id = params.classify_id.toString()
      this.formValidate.gz_classify_library_id = params.gz_classify_id.toString()
      this.formValidate.advertisement_library_id = params.advertisement_library_id.toString()
      
      this.formValidate.pre_advertisement_time = params.pre_advertisement_time == null ? "没插入过广告" : params.pre_advertisement_time
      this.dy_user_id = params.dy_user_id.toString()

      this.formValidate.audio_model_id = params.audio_model_id != 0?params.audio_model_id.toString():this.formValidate.audio_model_id
      this.formValidate.music_classify_id = params.music_classify_id.toString()
      this.music_id = params.music_id.toString()

      if (params.video_type_name){
        this.formValidate.video_type_name = params.video_type_name.toString()
      }

      this.formValidate.video_type = params.video_type_name?"是":"否"
      if (params.push_date_array){
        this.formValidate.push_date_array =  JSON.parse(params.push_date_array)
      }

      this.formValidate.en_audio_model_id = params.seed != 0 ?params.seed.toString():this.formValidate.en_audio_model_id.toString()
      this.formValidate.advertisement_second = params.advertisement_second.toString()
      this.get_music_library(true)
      this.formValidate.select_tableData = params.hj_list
      this.formValidate.advertisement_content = params.advertisement_content

      if (params.laugh != 0)
        this.formValidate.laugh = params.laugh
      
      if (params.speed != 0)
      this.formValidate.speed = params.speed

      if (params.oral != 0)
        this.formValidate.oral = params.oral

      getAdvertisementType().then((res) => {
        var workType = res.data.data.records;
        this.setAdvertisementType(workType);
        this.formValidate.advertisement_type_id = params.advertisement_id.toString()
      });

      this.classifyChange(params.classify_id)

      if (params.short_video_work_type_id == 3 || params.short_video_work_type_id == 17){
        mouth_library_list({classify_id: this.formValidate.classify_id}).then((res) => {
          var mouthLibraryList = res.data.data.records;
          this.setMouthLibrary(mouthLibraryList);
          this.formValidate.mouth_library_id = params.mouth_library_id.toString()
        });
      }

      if (params.hj_content){
        var hjContentList = JSON.parse(params.hj_content)
        for (var i = 0; i < hjContentList.length; i++){
          this.formValidate.select_tableData[i].content = hjContentList[i]
        }
      }
      
      this.formValidate.selectedUser = []
      if (params.list != null) {
        for (var i = 0; i < params.list.length; i++) {
          this.formValidate.selectedUser.push({ value: params.list[i].username, id: params.list[i].dy_user_id })
        }
      }

      if (this.formValidate.short_video_work_type_id == 4 || this.formValidate.short_video_work_type_id == 17){
        this.handleSearch()
      }

      this.formValidate.videoSource = baseUrl == 'https://in.sinano-ai.com/api' ? params.id_url : params.url

      this.getStrategyUser(true)
      this.gz_clasify_change(params.gz_classify_idue)

      this.formValidate.srt_status = params.srt_status ? "需要" : "不需要"
      this.formValidate.auto = params.auto ? "是" : "否"
      this.formValidate.isLink = params.link ? "是" : "否"
      this.formValidate.covert_face = params.covert_face ? "需要" : "不需要"
      this.formValidate.rid_subtitles = params.rid_subtitles ? "需要" : "不需要"
      this.formValidate.covert_mouth = params.covert_mouth ? "需要" : "不需要"
      this.formValidate.upload_id = params.upload_id ? "需要" : "不需要"
      this.formValidate.gz = params.gz_status ? "需要" : "不需要"

      if (params.good_comment != null) {
        this.formValidate.goodItems = JSON.parse(params.good_comment)
      }

      if (params.subtitle_location_json != null) {
        this.formValidate.rect_array = JSON.parse(params.subtitle_location_json)
        for (var i = 0; i < this.formValidate.rect_array.length; i++){
          this.formValidate.rect_array[i].startX = this.formValidate.rect_array[i].startX / this.x
          this.formValidate.rect_array[i].startY = this.formValidate.rect_array[i].startY / this.x
          this.formValidate.rect_array[i].endX = this.formValidate.rect_array[i].endX / this.x
          this.formValidate.rect_array[i].endY = this.formValidate.rect_array[i].endY / this.x
        }
      }

      if (params.srt_location_json != null) {
        this.formValidate.srt_rect_array = JSON.parse(params.srt_location_json)
        for (var i = 0; i < this.formValidate.srt_rect_array.length; i++){
          this.formValidate.srt_rect_array[i].startX = this.formValidate.srt_rect_array[i].startX / this.x
          this.formValidate.srt_rect_array[i].startY = this.formValidate.srt_rect_array[i].startY / this.x
          this.formValidate.srt_rect_array[i].endX = this.formValidate.srt_rect_array[i].endX / this.x
          this.formValidate.srt_rect_array[i].endY = this.formValidate.srt_rect_array[i].endY / this.x
        }
      }

      if (params.black_comment != null) {
        this.formValidate.blackItems = JSON.parse(params.black_comment)
      }

      if (params.mouth_gpt_text != null) {
        var mouth_gpt_text = JSON.parse(params.mouth_gpt_text)
        this.formValidate.points = mouth_gpt_text['points']
        this.formValidate.hot = mouth_gpt_text['hot']
        this.formValidate.point = mouth_gpt_text['point']
        this.formValidate.virtual_experience = mouth_gpt_text['virtual_experience']
      }

      if (params.url != null) {
        var video_path_array = params.url.split("/")
        this.show_video_path = video_path_array[video_path_array.length - 1]
      }

      if (params.face_url != null) {
        var video_path_array = params.face_url.split("/")
        this.show_face_path = video_path_array[video_path_array.length - 1]
      }

      if (params.gz_url != null) {
        var video_path_array = params.gz_url.split("/")
        this.show_gz_path = video_path_array[video_path_array.length - 1]
      }

      if (params.advertisement_url != null) {
        var video_path_array = params.advertisement_url.split("/")
        this.show_advertisement_path = video_path_array[video_path_array.length - 1]
      }

    },
    setClassifyData(classify_list) {
      var data = new Array()
      for (var i = 0; i < classify_list.length; i++) {
        data[i] = { id: classify_list[i].id.toString(), name: classify_list[i].name }
      }
      this.classifyIds = data

      if (this.classifyIds.length == 1) {
        this.classifyChange(this.classifyIds[0].id)
      }

    },
    setAudio(audioModelList) {
      var data = new Array()
      var cnData = new Array()
      for (var i = 0; i < audioModelList.length; i++) {
        var language = audioModelList[i].language
        
        if (language == 'Indonesia'){
          data.push({ id: audioModelList[i].id.toString(), name: audioModelList[i].audio_name })
          this.audio_data[audioModelList[i].id.toString()] = audioModelList[i].audio_id
        }else{
          cnData.push({ id: audioModelList[i].id.toString(), name: audioModelList[i].audio_name })
          this.en_audio_data[audioModelList[i].id.toString()] = audioModelList[i].audio_id
        }

      }

      this.audioModelIds = data
      this.enAudioModelIds = cnData

    },
    setMouthLibrary(mouthLibraryList) {
      var data = new Array()
      for (var i = 0; i < mouthLibraryList.length; i++) {
        data.push({ id: mouthLibraryList[i].id.toString(), name: mouthLibraryList[i].video_desc })
      }
      this.mouthLibraryList = data
    },
    setHashtagList(hashtagList) {
      var data = new Array()
      for (var i = 0; i < hashtagList.length; i++) {
        data.push({ id: hashtagList[i].id.toString(), name: hashtagList[i].tag })
      }
      this.hashtagList = data
    },
    setMusicLibraryClassify(musicLibraryClassifyList) {
      var data = new Array()
      for (var i = 0; i < musicLibraryClassifyList.length; i++) {
        data.push({ id: musicLibraryClassifyList[i].id.toString(), name: musicLibraryClassifyList[i].name })
      }
      this.musicLibraryClassify = data
    },
    setMusicLibrary(musicLibraryList) {
      var data = new Array()
      for (var i = 0; i < musicLibraryList.length; i++) {
        data.push({ id: musicLibraryList[i].id.toString(), name: musicLibraryList[i].video_desc, url: musicLibraryList[i].url, id_url: musicLibraryList[i].id_url })
      }
      this.musicLibrary = data
    },
    setLiveType(live_list) {
      var data = new Array()
      for (var i = 0; i < live_list.length; i++) {
        data[i] = { id: live_list[i].id.toString(), name: live_list[i].name }
      }
      this.liveIds = data
    },
    classifyChange(value) {
      var params = {
        classify_id: value
      }

      getShortVideoClassify(params).then((res) => {
        var shortVideoClassifys = res.data.data.records;
        var data = new Array()
        for (var i = 0; i < shortVideoClassifys.length; i++) {
          data[i] = { id: shortVideoClassifys[i].id.toString(), name: shortVideoClassifys[i].name }
        }
        this.shortVideoClassifyIds = data
      });

      gz_library_classify().then((res) => {
        var list = res.data.data.records;
        var data = new Array()
        for (var i = 0; i < list.length; i++) {
          data.push({ id: list[i].id.toString(), name: list[i].name })
        }
        this.gzClassifyLibraryIds = data
      });

      getAdvertisementLibrary(params).then((res) => {
        var list = res.data.data.records;
        var data = new Array()
        for (var i = 0; i < list.length; i++) {
          data.push({ id: list[i].id.toString(), name: list[i].advertisement_desc, url: list[i].url, id_url: list[i].id_url })
        }
        this.advertisementLibraryIds = data
      });

      mouth_library_list({classify_id: this.formValidate.classify_id}).then((res) => {
          var mouthLibraryList = res.data.data.records;
          this.setMouthLibrary(mouthLibraryList);
        });

    },
    workTypeChange(value) {
      if (value == 2) {
        this.formValidate.covert_face = '需要'
      } else {
        this.formValidate.covert_face = '不需要'
      }

      if (value == 3) {
        this.formValidate.covert_mouth = '需要'
      } else {
        this.formValidate.covert_mouth = '不需要'
      }

      if (value == 4 || value == 17) {
        this.handleSearch()
      }

      if (value == 3 || value == 17){
        mouth_library_list({classify_id: this.formValidate.classify_id}).then((res) => {
          var mouthLibraryList = res.data.data.records;
          this.setMouthLibrary(mouthLibraryList);
        });
      }

    },
    hjVideoClassifyChange(value){
      this.handleSearch()
    },
    videoClassifyChange(value) {
      this.getStrategyUser()
    }, liveChange(value) {
      this.getStrategyUser()

    }, userChange(value) {
      this.getPreAdvertisementTimes()

      // 判断用户如果已经选择就直接返回
      for (var i = 0; i < this.formValidate.selectedUser.length; i++) {
        if (value == this.formValidate.selectedUser[i].id) {
          return
        }
      }

      for (var i = 0; i < this.userIds.length; i++) {
        if (this.userIds[i].id == value) {
          this.formValidate.selectedUser.push({ value: this.userIds[i].name, id: value })
        }
      }


    }, getPreAdvertisementTimes() {

      if (this.formValidate.dy_user_id == undefined)
        return

      var params = {
        dy_user_id: this.formValidate.dy_user_id
      }
      getPreAdvertisementTime(params).then((res) => {
        var preTime = res.data.data;
        this.formValidate.pre_advertisement_time = preTime == null ? "没插入过广告" : getTimeDifference(preTime)
      });

    }, getStrategyUser(status = false) {
      var params = {
        short_video_classify: this.formValidate.shortVideoClassify,
        live_id: this.formValidate.live_id,
        classify_id: this.formValidate.classify_id
      }
      getStrategyUser(params).then((res) => {
        var users = res.data.data.records;
        var data = new Array()
        for (var i = 0; i < users.length; i++) {
          var user = users[i]
          data.push({ id: user.id.toString(), name: user.username })
        }
        this.userIds = data

        if (status) {
          this.formValidate.dy_user_id = this.dy_user_id
        }

      });

    }, setWorkType(workTypes) {
      var data = new Array()
      for (var i = 0; i < workTypes.length; i++) {
        data[i] = { id: workTypes[i].id.toString(), name: workTypes[i].name }
      }
      this.workTypeIds = data

    }, setAdvertisementType(advertisementTypes) {
      var data = new Array()
      for (var i = 0; i < advertisementTypes.length; i++) {
        data[i] = { value: advertisementTypes[i].id.toString(), name: advertisementTypes[i].name }
      }
      this.advertisementIds = data
    },
    setVideoClassify(shortVideoClassifys) {
      var data = new Array()
      for (var i = 0; i < shortVideoClassifys.length; i++) {
        data[i] = { id: shortVideoClassifys[i].id.toString(), name: shortVideoClassifys[i].name }
      }
      this.shortVideoClassifyIds = data
    },
    handleGoodAdd() {
      this.formValidate.goodItems.push({ "value": '' })
    },
    handlePushDateAdd() {
      this.formValidate.push_date_array.push({ "value": '', 'is_push': false})
    },
    handlePointAdd() {
      this.formValidate.points.push({ "value": '' })
    },
    handlePointRemove(index) {
      this.formValidate.points.splice(index, 1)
    },
    handleBlackAdd() {
      this.formValidate.blackItems.push({ "value": '' })
    },
    handlePushDateRemove(index){
      this.formValidate.push_date_array.splice(index, 1)
    },
    handleGoodCommentRemove(index) {
      this.formValidate.goodItems.splice(index, 1)
    },
    handleUserRemove(index) {
      this.formValidate.selectedUser.splice(index, 1)
    },
    handleBlackCommentRemove(index) {
      this.formValidate.blackItems.splice(index, 1)
    },
    async handleAdvertisementChange(e) {
      const file = e.target.files[0];
      if (!file) return;

      try {

        this.advertisement_loadding = true
        let currentDate = moment().format('YYYY-MM-DD');
        const uuid = uuidv4()
        // 上传文件
        var name = file.name.substring(file.name.lastIndexOf('.'))

        if (this.formValidate.upload_id == '需要') {
          const result = await uploadIdFile('short_video/' + currentDate + "/short_video_task/" + uuid + name, file);
          if (result != '') {
            this.formValidate.advertisement_id_url = result
            this.$Message.info('上传印尼服务器成功');
          } else {
            this.$refs.advertisementPathFileInput.value = ''
            this.$Message.error('上传失败');
            this.advertisement_loadding = false
            return
          }
        }

        const result = await uploadFile('short_video/' + currentDate + "/short_video_task/" + uuid + name, file)
        if (result != '') {
          this.formValidate.advertisement_url = result
          this.$Message.info('上传成功');
        } else {
          this.$Message.error('上传失败');
          this.$refs.advertisementPathFileInput.value = ''
          this.advertisement_loadding = false
        }
      } catch (error) {
        this.$Message.error('上传失败');
        this.$refs.advertisementPathFileInput.value = ''
      }

      this.advertisement_loadding = false
    },
    async handleGzChange(e) {
      const file = e.target.files[0];
      if (!file) return;

      try {
        this.gz_loadding = true
        let currentDate = moment().format('YYYY-MM-DD');
        const uuid = uuidv4()
        // 上传文件
        var name = file.name.substring(file.name.lastIndexOf('.'))
        if (this.formValidate.upload_id == '需要') {
          const result = await uploadIdFile('short_video/' + currentDate + "/short_video_task/" + uuid + name, file);
          if (result != '') {
            this.formValidate.gz_id_url = result
            this.$Message.info('上传印尼服务器成功');
          } else {
            this.$refs.gzPathFileInput.value = ''
            this.$Message.error('上传失败');
            return
          }
        }

        const result = await uploadFile('short_video/' + currentDate + "/short_video_task/" + uuid + name, file)
        if (result != '') {
          this.formValidate.gz_url = result
          this.$Message.info('上传成功');
        } else {
          this.$refs.gzPathFileInput.value = ''
          this.$Message.error('上传失败');
        }
      } catch (error) {
        this.$Message.error('上传失败');
        this.$refs.gzPathFileInput.value = ''
      }

      this.gz_loadding = false
    },
    async handleFacePathChange(e) {
      const file = e.target.files[0];
      if (!file) return;

      try {
        let currentDate = moment().format('YYYY-MM-DD');
        const uuid = uuidv4()
        // 上传文件
        var name = file.name.substring(file.name.lastIndexOf('.'))
        const result = await uploadFile('short_video/' + currentDate + "/short_video_task/" + uuid + name, file)
        if (result != '') {
          this.formValidate.face_url = result
          this.$Message.info('上传成功');
        } else {
          this.$Message.error('上传失败');
          this.$refs.facePathFileInput.value = ''
        }

      } catch (error) {
        this.$Message.error('上传失败');
        this.$refs.facePathFileInput.value = ''
      }
    }, handleHJVideoRemove(index) {
      this.formValidate.selectedHjVideos.splice(index, 1)
    },
    async handleVideoFileChange(e) {
      try {
        const file = e.target.files[0];
        if (!file) return;

        this.url_loadding = true
        this.formValidate.video_show = true
        this.formValidate.videoSource = URL.createObjectURL(file);
        let currentDate = moment().format('YYYY-MM-DD');
        const uuid = uuidv4()
        // 上传文件
        var name = file.name.substring(file.name.lastIndexOf('.'))
        
        if (this.formValidate.upload_id == '需要' && this.formValidate.auto == '否') {
          const result = await uploadIdFile('short_video/' + currentDate + "/short_video_task/" + uuid + name, file);
          if (result != '') {
            this.formValidate.id_url = result
            this.$Message.info('上传印尼服务器成功');
          } else {
            this.$refs.videoFileInput.value = ''
            this.$Message.error('上传失败');
            return
          }
        }else{
          let result = null
          if (baseUrl == 'https://in.sinano-ai.com/api'){
            result = await uploadIdFile('short_video/' + currentDate + "/short_video_task/" + uuid + name, file);
          }else{
            result = await uploadFile('short_video/' + currentDate + "/short_video_task/" + uuid + name, file);
          }
        
          if (result != '') {
            this.formValidate.url = result
            this.$Message.info('上传成功');
          } else {
            this.$refs.videoFileInput.value = ''
            this.$Message.error('上传失败');
          }
        }

        this.url_loadding = false
      } catch (error) {
        console.info(error)
        this.$refs.videoFileInput.value = ''
        this.$Message.error('上传失败');
        this.url_loadding = false
      }
    },
    handleSubmit(name) {

      if (this.formValidate.short_video_work_type_id != 3 && this.formValidate.short_video_work_type_id != 4  && this.formValidate.short_video_work_type_id != 17 && this.formValidate.isLink =='否') {

        if (this.formValidate.url == '' || this.formValidate.url == null) {
          this.$Message.error('需要上传视频')
          return
        }
      }
      // if (this.formValidate.short_video_work_type_id == 4){
      //     for (var i = 0; i < this.formValidate.select_tableData.length; i++){
      //       if (!this.formValidate.select_tableData[i].content){
      //         this.$Message.error('混剪视频必须要添加文案')
      //         return
      //       }
      //     }
      // }

      this.$refs[name].validate((valid) => {
        if (valid && this.formValidate.selectedUser.length > 0) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset(name) {
      // this.formValidate.video_show = false
      // this.formValidate.videoSource = ''
      this.videoElement = null
      // this.$refs[name].resetFields()
      // this.formValidate = this.org_formValidate
      this.formValidate = { ...this.org_formValidate }
      this.formValidate.srt_rect_array = []
      this.formValidate.rect_array = []
    }
  }
}
</script>

<style scoped>
canvas {
  border: 1px solid #000;
  cursor: crosshair;
}
</style>
